import {observer} from 'mobx-react';
import {Grid} from '@mui/material';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_YEAR} from './StatsCommon.js';
import StatsYearTable from './StatsYearTable.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

const StatsYear = observer((props) => {
	const gStorage = useGlobalStorage();

	function yearAddLeftEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_YEAR || gStorage.stats.rightList.year !== gStorage.stats.year ||
				gStorage.stats.rightList.country !== gStorage.stats.country.id);
	}

	function yearAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_YEAR, year: gStorage.stats.year, list: gStorage.stats.obsList.slice()});
	}

	function yearAddRightEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_YEAR || gStorage.stats.leftList.year !== gStorage.stats.year || 
				gStorage.stats.leftList.country !== gStorage.stats.country.id);
	}

	function yearAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_YEAR, year: gStorage.stats.year, list: gStorage.stats.obsList.slice()});
	}

	function statsYearChange(event) {
		gStorage.stats.setYear(event.target.value);
		gStorage.stats.setObsList(null);
	};

	function yearListRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('yearListRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('yearListRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_YEAR)
			return;

// 		console.log('yearListRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function loadYearList() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'year',
			op: 'list',
			data: {
				year: gStorage.stats.year,
				country: gStorage.stats.country.id,
			},
		};

//  		console.log('loadYearList', msg);
		gStorage.conn.ws.send(msg, yearListRxWs);
	}

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_YEAR) 
		return null;

	if (!gStorage.stats.obsList) {
		if (gStorage.conn.online)
			loadYearList();

		return null;
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}}
					}
					time = {{
						year: {
							year: gStorage.stats.year,
							onChange: statsYearChange,
							enabled: gStorage.conn.online
						}}
					}
					compare = {{
						leftIsEnabled: yearAddLeftEnabled(),
						leftAdd: yearAddLeft,
						rightIsEnabled: yearAddRightEnabled(),
						rightAdd: yearAddRight
					}}
				/>
			</Grid>
			<StatsYearTable src={gStorage.stats.obsList} />
		</Grid>
	);
});

export default StatsYear;
